<template>
    <div :class="{'mb-4': wrap}">
        <label v-if="title && wrap" class="block text-sm text-gray-600 mb-1">{{ title }}</label>

        <slot name="field" :hasErrors="hasErrors"></slot>

        <div class="text-sm mt-1 text-red-600" v-if="hasErrors" v-html="firstError"></div>
    </div>
</template>

<script>
export default {
    props: {
        errors: Array,

        title: {
            type: String,
            default: null
        },

        wrap: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        hasErrors() {
            return !!this.errors.length;
        },

        firstError() {
            return this.errors[0];
        }
    }
};
</script>